export const currentDate = () => {
  if (process.env.NODE_ENV === "development") {
    return new Date("2025-06-28");
  } else {
    return new Date(); // Date du jour en production
  }
};
